<!-- 게시판글 표현 -->
<template>
    <div class="wrapper">
        <div class="cont">
            <div class="title">
               <span v-if="isDocView">[{{post.document.title}}] </span>
               <post-title 
               :document="post.document.name" 
               :list="post" 
               :menu="post.document.menu"
               :lengthLimit="lengthLimit"
               :isMobile="isMobile"
               />
            </div>
        </div>
    </div>
</template>
<script>
import { removeAllTag } from '@/utils/removetag'
import PostTitle from '@/components/posts/PostTitle.vue'
export default {
     props:{
        post: {            
            required: true,
            default: null
        },
        isTiteView: {
            required: false,
            default:true,    
        },
        lengthLimit: {
            type:Number,
            required: false,
            default:30,    
        },
        isDocView: {
            required: false,
            default: true,    
        },
        isMobile:{
            required: false,
            default: false,       
        }
    },    
    components:{
        PostTitle
    },
    methods:{
        getCont(cont)
        {
            const removetag = removeAllTag(cont);
            return removetag.substr(0, 130) + (removetag.length >130?'...':'') ;
        }
    }
}
</script>
<style lang="scss" scoped>
.wrapper
{
    display:flex;
    .thumb{
        .thumb_box{
            width:150px; height:120px;
            background-size:cover;
            background-color:#dee3eb;
            color:#808080;
            display:flex;
            align-items:center;
            justify-content: center;
            font-size:16px;
            flex-direction:column;
            span{
                font-size:11px;
                background:#808080;
                border-radius:10px;
                color:#dee3eb;
                padding:0 5px;
            }
        }
    }
    .cont{
        font-family:malgungothic;
        .title{
            margin-top:10px;
            //font-weight:bold;
        }
        .content{
            margin-top:20px;
            padding-right:20px;
            line-height:20px;
        }
        .created_at{
            margin-top:20px;
        }
    }
}
</style>
